import jsonParser from 'utils/parseJson';
import { WalletType } from 'types';

import { BrandingType, IAffiliate } from './auth';

const jsonStringify = <T>(json: T): string => JSON.stringify(json);

export const authStorage = {
  set: (data: { affiliate: IAffiliate; accessToken: string; branding?: BrandingType }): void => {
    localStorage.setItem('affiliate', jsonStringify<IAffiliate>(data.affiliate));
    localStorage.setItem('accessToken', jsonStringify<string>(data.accessToken));
    if (data?.branding) {
      localStorage.setItem('branding', jsonStringify<BrandingType>(data?.branding));
    }
  },
  get: (): { affiliate: IAffiliate; accessToken: string; wallets: WalletType[]; branding: BrandingType } => ({
    affiliate: jsonParser(localStorage.getItem('affiliate') || ''),
    accessToken: jsonParser(localStorage.getItem('accessToken') || ''),
    branding: jsonParser(localStorage.getItem('branding') || ''),
    wallets: [],
  }),
  remove: (): void => {
    localStorage.removeItem('affiliate');
    localStorage.removeItem('accessToken');
  },
  clear: (): void => {
    localStorage.clear();
    window.location.reload();
    window.location.pathname = '/';
  },
};
